import React, { Component } from 'react';
import ReactEcharts from 'react-echarts-component';
import { DatePicker } from 'react-md';
import moment from 'moment';
import ClickNHold from 'react-click-n-hold';

export default class MetricsBottomBar extends Component {

    constructor(props) {
        super(props);

        this.defaultProps = {}

        this.state = {
            periodOpen: false
        }

        this.mouseStartX = null;
        this.mouseStartY = null;
        this.mouseX = null;
        this.mouseY = null;

        this.togglePeriodOpen = this.togglePeriodOpen.bind(this);
        this.selectPeriod = this.selectPeriod.bind(this);
        this.numberWithCommas = this.numberWithCommas.bind(this);
        this.convertToDisplay = this.convertToDisplay.bind(this);
        this.getPeriodChart = this.getPeriodChart.bind(this);
        this.generatePeriodOptions = this.generatePeriodOptions.bind(this);
        this.generateDesktopOptions = this.generateDesktopOptions.bind(this);

        this.rightOptionHoldStart = this.rightOptionHoldStart.bind(this);
        this.rightOptionHoldGo = this.rightOptionHoldGo.bind(this);
        this.rightOptionHoldEnd = this.rightOptionHoldEnd.bind(this);
        this.rightOptionHoldListener = this.rightOptionHoldListener.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps() {

    }

    componentWillUnmount() {
        if (this.state.periodOpen) {
            this.togglePeriodOpen();
        }
    }

    togglePeriodOpen() {
        this.setState({ periodOpen: !this.state.periodOpen });
    }

    selectPeriod(range) {

        if (this.props.canSelectPeriod(range)) {
            let filter = this.props.blastFilter;
            filter.range = range;

            this.props.updateBlastFilter(filter);
            this.setState({ periodOpen: false });
        }
    }

    numberWithCommas(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    convertToDisplay(type, startText, number) {

        let endText = startText;
        switch (type) {
            case 'MNY':
                endText += '$' + this.numberWithCommas(number);
                break;
            case 'INT':
                let newNum = parseFloat(number);
                if (newNum === NaN) {
                    endText += '';
                } else {
                    endText += this.numberWithCommas(parseFloat(number).toFixed(0));
                }
                break;
            case 'PCT':
                let newNum1 = parseFloat(number);
                if (newNum1 === NaN) {
                    endText += '';
                } else {
                    endText += this.numberWithCommas(parseFloat(number).toFixed(1)) + '%';
                }
                break;
            default:
                endText += this.numberWithCommas(number);
        }
        return endText;
    }

    getPeriodChart(periodRatio) {
        return (
            <ReactEcharts
                className="metrics-bottom-bar-period-chart"
                height={'100%'}
                option={{
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)",
                        show: false
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'left',
                        data: ['Green', 'Grey']
                    },
                    series: [
                        {
                            name: 'Period',
                            type: 'pie',
                            radius: ['50%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                normal: {
                                    show: false,
                                    position: 'center'
                                },
                                emphasis: {
                                    show: false,
                                    textStyle: {
                                        fontSize: '30',
                                        fontWeight: 'bold'
                                    }
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: false
                                }
                            },
                            color: ['#29545F', '#d8d8d8'],
                            data: [
                                { value: periodRatio[0], name: '' },
                                { value: periodRatio[1], name: '' }
                            ]
                        }
                    ]
                }}
            />
        );
    }

    generatePeriodOptions() {
        let periodOptionsClasses = [
            'metrics-bottom-bar-period-drop-item',
            'metrics-bottom-bar-period-drop-item',
            'metrics-bottom-bar-period-drop-item',
            'metrics-bottom-bar-period-drop-item',
            'metrics-bottom-bar-period-drop-item']

        switch (this.props.blastFilter.range != undefined ? this.props.blastFilter.range : 'CUR') {
            case 'CUR': periodOptionsClasses[0] += ' color-emerald';
                break;
            case 'WTD': periodOptionsClasses[1] += ' color-emerald';
                break;
            case 'MTD': periodOptionsClasses[2] += ' color-emerald';
                break;
            case 'QTD': periodOptionsClasses[3] += ' color-emerald';
                break;
            case 'YTD': periodOptionsClasses[4] += ' color-emerald';
        }

        let showPhrases = ["Selected Date", "Week to Date", "Month to Date", "Quarter to Date", "Year to Date"];
        switch (zzDataCache.settings.compareMode) {
            case "lastYear": showPhrases = ["Selected Date", "Week to Date", "Month to Date", "Quarter to Date", "Year to Date"]; break;
            case "toDateLastPeriod": showPhrases = ["Selected Date", "Week to Date", "Month to Date", "Quarter to Date", "Year to Date"]; break;
            case "endOfLastPeriod": showPhrases = ["Selected Date", "Entire Week", "Entire Month", "Entire Quarter", "Entire Year"]; break;
            case "thisDayLastPeriod": showPhrases = ["Previous Day", "Previous Week", "Previous Month", "Previous Quarter", "Previous Year"]; break;
            default: showPhrases = ["Selected Date", "Week to Date", "Month to Date", "Quarter to Date", "Year to Date"];
        }

        let optionsJsx = [];
        if (this.props.canSelectPeriod('CUR')) {
            optionsJsx.push((<div data-trackid={'metric-dates-current'} className={periodOptionsClasses[0]} onClick={this.selectPeriod.bind(null, 'CUR')}>{showPhrases[0]}</div>));
        }
        if (this.props.canSelectPeriod('WTD')) {
            optionsJsx.push((<div data-trackid={'metric-dates-weekToDate'} className={periodOptionsClasses[1]} onClick={this.selectPeriod.bind(null, 'WTD')}>{showPhrases[1]}</div>));
        }
        if (this.props.canSelectPeriod('MTD')) {
            optionsJsx.push((<div data-trackid={'metric-dates-monthToDate'} className={periodOptionsClasses[2]} onClick={this.selectPeriod.bind(null, 'MTD')}>{showPhrases[2]}</div>));
        }
        if (this.props.canSelectPeriod('QTD')) {
            optionsJsx.push((<div data-trackid={'metric-dates-quarterToDate'} className={periodOptionsClasses[3]} onClick={this.selectPeriod.bind(null, 'QTD')}>{showPhrases[3]}</div>));
        }
        if (this.props.canSelectPeriod('YTD')) {
            optionsJsx.push((<div data-trackid={'metric-dates-yearToDate'} className={periodOptionsClasses[4]} onClick={this.selectPeriod.bind(null, 'YTD')}>{showPhrases[4]}</div>));
        }

        return optionsJsx;
    }

    generateDesktopOptions() {
        let deskJsx = [];

        let keys = Object.keys(this.props.rightOptions);
        for (var i = 0; i < keys.length; i++) {
            let key = keys[i];
            let option = this.props.rightOptions[key];
            let optionClass = 'material-icons right-option';
            if (option.active) {
                optionClass += ' active';
            }
            if (option.hold) {
                optionClass += ' hold';
            }
            if (option.solo) {
                optionClass += ' solo';
            }
            let optionStyle = {};
            optionStyle.width = (100.0 / keys.length) + '%';
            optionStyle.left = ((100.0 / keys.length) * i) + '%';
            let optionIcon = option.icon;
            if (option.icon === 'goals') {
                optionIcon =
                    (<svg className="filler-svg-dark" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.896 28.896">
                        <polygon points="17.698,0 14.448,4.334 11.198,0 4.948,0 14.448,12.667 23.948,0 		" />
                        <polygon points="17.085,18.009 14.448,12.667 11.811,18.009 5.915,18.865 10.182,23.025 9.175,28.896 14.448,26.125 19.722,28.896 18.714,23.025 22.98,18.865 		" />
                    </svg>);
            } else if (option.icon === 'contests') {
                optionIcon =
                    (<svg className="filler-svg-dark" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 297 297">
                        <g>
                            <g>
                                <path d="M174.691,194.214c0-2.718-2.152-4.382-4.782-3.698c0,0-12.318,3.201-21.409,3.201s-21.409-3.201-21.409-3.201 c-2.63-0.684-4.782,0.98-4.782,3.698v14.329c0,2.718,2.224,4.941,4.941,4.941h42.5c2.718,0,4.941-2.224,4.941-4.941V194.214z" />
                            </g>
                            <g>
                                <path d="M223.615,9.884c0-5.458-4.426-9.884-9.884-9.884H83.269c-5.458,0-9.884,4.426-9.884,9.884v81.539 c0,25.522,7.591,48.754,21.374,65.415c13.874,16.771,32.96,26.008,53.741,26.008c20.781,0,39.867-9.236,53.741-26.008 c13.783-16.661,21.374-39.893,21.374-65.415V9.884z" />
                            </g>
                            <g>
                                <path d="M63.981,111.227c-13.525-5.033-19.753-16.706-19.753-36.111V30.969h18.285V11.202H34.346 c-5.459,0-9.884,4.425-9.884,9.884v54.029c0,32.961,15.788,53.039,44.818,57.729C66.895,125.985,65.109,118.749,63.981,111.227z" />
                            </g>
                            <g>
                                <path d="M83.269,228.31c-5.458,0-9.884,4.425-9.884,9.884v48.923c0,5.458,4.426,9.884,9.884,9.884h130.463 c5.458,0,9.884-4.426,9.884-9.884v-48.923c0-5.459-4.426-9.884-9.884-9.884H83.269z" />
                            </g>
                            <g>
                                <path d="M262.654,11.202h-28.168v19.767h18.285v44.146c0,19.405-6.228,31.078-19.753,36.111 c-1.128,7.522-2.913,14.759-5.299,21.618c29.03-4.69,44.818-24.768,44.818-57.729V21.086 C272.538,15.627,268.113,11.202,262.654,11.202z" />
                            </g>
                        </g>
                    </svg>)
            }

            deskJsx.push((
                <ClickNHold
                    time={0.5}
                    onStart={this.rightOptionHoldStart}
                    onClickNHold={this.rightOptionHoldGo.bind(null, key)}
                    onEnd={this.rightOptionHoldEnd}
                >
                    <div data-trackid={'metrics-'+option.icon} className={optionClass} style={optionStyle} onClick={this.props.setRightOption.bind(null, key)}>{optionIcon}</div>
                </ClickNHold>
            ));
        };

        let result =
            (<div className="metrics-bottom-bar-right-options-container">
                {deskJsx}
            </div>)

        return result;
    }

    rightOptionHoldStart(e) {
        if (e.touches != undefined && e.touches != null && e.touches.length > 0) {
            this.mouseStartX = e.touches[0].clientX;
            this.mouseStartY = e.touches[0].clientY;
            this.mouseX = e.touches[0].clientX;
            this.mouseY = e.touches[0].clientY;

            document.documentElement.addEventListener('touchmove', this.rightOptionHoldListener);
        }
    }

    rightOptionHoldGo(option) {
        if (this.mouseX != null && this.mouseStartX != null && this.mouseY != null && this.mouseStartY != null &&
            this.mouseX <= this.mouseStartX + 2 && this.mouseX >= this.mouseStartX - 2 && this.mouseY <= this.mouseStartY + 2 && this.mouseY >= this.mouseStartY - 2) {
            this.props.setRightOptionSolo(option)
        }
    }

    rightOptionHoldEnd(e) {
        document.documentElement.removeEventListener('touchmove', this.rightOptionHoldListener);
        this.mouseStartX = null;
        this.mouseStartY = null;
        this.mouseX = null;
        this.mouseY = null;
    }

    rightOptionHoldListener(e) {
        if (e.touches != undefined && e.touches != null && e.touches.length > 0) {
            this.mouseX = e.touches[0].clientX;
            this.mouseY = e.touches[0].clientY;
        }
    }

    render() {

        let bRange = this.props.blastFilter.range;
        let dataMode = this.props.blastFilter.dataMode;

        let periodRatio = [0, 1];
        let periodIcon = 'Q';
        switch (this.props.blastFilter.range != undefined ? this.props.blastFilter.range : 'CUR') {
            case 'CUR': periodRatio = [1, 44]; periodIcon = 'D';
                break;
            case 'WTD': periodRatio = [1, 22]; periodIcon = 'W';
                break;
            case 'MTD': periodRatio = [1, 11]; periodIcon = 'M';
                break;
            case 'QTD': periodRatio = [1, 3]; periodIcon = 'Q';
                break;
            case 'YTD': periodRatio = [1, 0]; periodIcon = 'Y';
        }

        let periodOptionsJsx = this.generatePeriodOptions();

        let periodChart = this.getPeriodChart(periodRatio);

        let periodOpenClass = 'metrics-bottom-bar-period-drop-outer';
        if (this.state.periodOpen) {
            periodOpenClass += ' metrics-bottom-bar-period-drop-outer--active';
        }

        let cDataDTotal = 0;
        let cDataTotal = 0;
        let totalTopText = "";
        let totalBottomText = "";
        let totalTopTextClass = 'metrics-bottom-bar-totals-top';
        if (this.props.blastData.totals != undefined &&
            this.props.screenContext.groupKey != undefined &&
            this.props.blastData.totals[this.props.screenContext.groupKey] != undefined &&
            this.props.blastData.totals[this.props.screenContext.groupKey].type != undefined) {

            if (this.props.blastData.totals[this.props.screenContext.groupKey]['cData' + (dataMode === 'N' ? '' : dataMode) + 'Total'] != undefined) {
                if (dataMode === 'N') {
                    cDataDTotal = this.props.blastData.totals[this.props.screenContext.groupKey]['lDataTotal'][bRange].toFixed(2);
                } else {
                    cDataDTotal = this.props.blastData.totals[this.props.screenContext.groupKey]['cData' + dataMode + 'Total'][bRange].toFixed(2);
                }

                if (dataMode != 'N') {
                    totalTopText += (cDataDTotal >= 0 ? '+' : '-');
                }
                if (dataMode != 'P') {
                    if (dataMode === 'D' && this.props.blastData.totals[this.props.screenContext.groupKey].type === 'PCT') {
                        totalTopText += Math.abs(cDataDTotal).toFixed(1);
                    } else {
                        totalTopText = this.convertToDisplay(this.props.blastData.totals[this.props.screenContext.groupKey].type, totalTopText, Math.abs(cDataDTotal));
                    }
                } else {
                    totalTopText += Math.abs(cDataDTotal).toFixed(1) + '%';
                }
                totalTopTextClass += ((this.props.blastData.totals[this.props.screenContext.groupKey]['cDataDTotal'][bRange] >= 0 &&
                    this.props.blastData[this.props.screenContext.groupKey] != undefined &&
                    this.props.blastData[this.props.screenContext.groupKey][0] != undefined &&
                    this.props.blastData[this.props.screenContext.groupKey][0].sign === '') ||
                    (this.props.blastData.totals[this.props.screenContext.groupKey]['cDataDTotal'][bRange] <= 0 &&
                        this.props.blastData[this.props.screenContext.groupKey] != undefined &&
                        this.props.blastData[this.props.screenContext.groupKey][0] != undefined &&
                        this.props.blastData[this.props.screenContext.groupKey][0].sign === '-') ? '' : ' metrics-bottom-bar-totals-top--negative');
            }
            if (this.props.blastData.totals[this.props.screenContext.groupKey].cDataTotal != undefined) {
                cDataTotal = this.props.blastData.totals[this.props.screenContext.groupKey].cDataTotal[bRange].toFixed(2);
                totalBottomText = this.convertToDisplay(this.props.blastData.totals[this.props.screenContext.groupKey].type, totalBottomText, cDataTotal);
            }
        }

        let rightSideJsx = null;
        if ((this.props.isGroupsMode && this.props.screenContext.screen === 'dists') || this.props.screenContext.isMetric || this.props.screenContext.screen === 'emps' || this.props.screenContext.screen === 'allemps') {

            let dateText = null;
            if (this.props.blastData[this.props.screenContext.groupKey] != undefined && this.props.blastData[this.props.screenContext.groupKey].length > 0) {

                // dateText = moment(this.props.blastData[this.props.screenContext.groupKey][0].lastUpdate).format('MM/DD/YY h:mm a');
                dateText = moment.utc(this.props.blastData[this.props.screenContext.groupKey][0].lastUpdate).local().format('MM/DD/YY h:mm a');
            }

            rightSideJsx = dateText != "Invalid date" ? (
                <div className="metrics-bottom-bar-totals-container">
                    <div className="metrics-bottom-bar-datarefresh-top">Data Refreshed at</div>
                    <div className="metrics-bottom-bar-datarefresh-bottom">{dateText}</div>
                </div>
            ) : null;

        } else {

            let bSpanText = 'LY';
            let bSpanClass = '';
            let bSpanStyle = {
                color: 'rgba(0, 0, 0, 0.55)',
                fontSize: '0.75rem',
                display: 'inline-block',
                verticalAlign: 'bottom',
                width: '1.2rem',
                transition: 'all 0.125s ease-in-out 0s',
                overflow: 'hidden'
            }
            if (this.props.blastFilter.dataMode === 'D') {
                bSpanStyle.width = '0';
            } else if (this.props.blastFilter.dataMode === 'P') {
                bSpanStyle.width = '0';
            }

            if (zzDataCache.settings.compareMode === 'targets') {
                bSpanText = 'gps_fixed';
                bSpanClass = 'material-icons';
                bSpanStyle.fontSize = '0.9rem';
            } else if (zzDataCache.settings.compareMode === "endOfLastPeriod" ||
                zzDataCache.settings.compareMode === "toDateLastPeriod" ||
                zzDataCache.settings.compareMode === "thisDayLastPeriod") {
                bSpanText = 'LP';
            }

            rightSideJsx = (
                <div className="metrics-bottom-bar-totals-container" onClick={this.props.rotateDataMode} >
                    <div className={totalTopTextClass}>{totalBottomText}<div style={{ color: 'rgba(0, 0, 0, 0.55)', fontSize: '0.75rem', display: 'inline-block', width: '1.2rem' }}>{"CY"}</div></div>
                    <div className="metrics-bottom-bar-totals-bottom">{totalTopText}<div style={bSpanStyle} className={bSpanClass}>{bSpanText}</div></div>
                </div>
            );
        }

        let todayDate = new Date();
        todayDate.setHours(12);


        let deskRightJsx = null;
        if (!this.props.isPhone) {
            deskRightJsx = this.generateDesktopOptions();
        }

        return (
            <div className="metrics-bottom-bar-outer">
                <div className="metrics-bottom-bar-datepicker-container">
                    <DatePicker
                        id="metrics-inline-date-picker-portait"
                        className="metrics-bottom-bar-datepicker"
                        label={null}
                        inline
                        defaultValue={todayDate}
                        displayMode="portrait"
                        fullWidth={false}
                        formatOptions={{
                            year: '2-digit',
                            month: '2-digit',
                            day: '2-digit'
                        }}
                        //maxDate={todayDate}
                        minDate={new Date('01/01/2000')}
                        onChange={this.props.changeDate}
                    />
                    <div className="metrics-bottom-bar-date-triangle material-icons">arrow_drop_down</div>
                </div>
                <div className="metrics-bottom-bar-period-container" onClick={this.togglePeriodOpen}>
                    {periodChart}
                    <div className="metrics-bottom-bar-period-icon">{periodIcon}</div>
                </div>
                <div className={periodOpenClass} onClick={this.togglePeriodOpen}>
                    <div className="metrics-bottom-bar-period-drop-container" style={this.state.periodOpen ? { height: periodOptionsJsx.length * 3.14 + 'rem' } : {}}>
                        {periodOptionsJsx}
                    </div>
                </div>
                {rightSideJsx}
                {deskRightJsx}
            </div>
        );
    }
}
